import React, { useEffect, useState } from "react";
import "./Services.css";

// import color from "../../Assets/colorgrading.jpg";
// import editing from "../../Assets/editingvideo.jpg";
// import motion from "../../Assets/motion.jpg";
// import sound from "../../Assets/sound.jpg";


// import star from "../../Assets/star.png";
// import viralOptimization from "../../Assets/ViralOptimization.png";
// import ideas from "../../Assets/ideas.png";
// import editing from "../../Assets/editing.png";
// import bigName from "../../Assets/bignames.png";


import bigName from "../../Assets/Big Name Connections (2).png";
import editing from "../../Assets/Editing _ Post-Production (1).png";
import viral from "../../Assets/Viral Content Ideas (2).png";
import star from "../../Assets/You can be a star too (1).png";
import optimization from "../../Assets/Viral Optimization (2).png";


import { Link } from "react-router-dom";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Services = () => {
  const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 1024);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    brandName: "",
    platform: "",
    contentStyle: "",
    rawFootage: "",
    volumeOfWork: {
      fullLengthVideos: "",
      shorts: "",
      thumbnails: "",
    },
    challenges: "",
    communicationMethod: "",
    message: "",
  });
  useEffect(() => {
    const handleResize = () => {
      setMobileVersion(window.innerWidth <= 1478);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleVolumeChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      volumeOfWork: {
        ...prevData.volumeOfWork,
        [name]: value,
      },
    }));
  };


 const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_u208u7h", // Replace with your EmailJS service ID
        "YOUR_TEMPLATE_ID", // Replace with your EmailJS template ID
        formData,
        "ZxBHR4GoCaP08_Len" // Replace with your EmailJS user ID
      )
      .then(
        () => {
          toast.success("Quote request sent successfully!");
          setShowForm(false);
          setFormData({
            name: "",
            brandName: "",
            platform: "",
            contentStyle: "",
            rawFootage: "",
            volumeOfWork: {
              fullLengthVideos: "",
              shorts: "",
              thumbnails: "",
            },
            challenges: "",
            communicationMethod: "",
            message: "",
          });
        },
        () => {
          toast.error("Failed to send the request. Please try again.");
        }
      );
  };
  return (
    <main id={mobileVersion ? "services-mb" : "services"}>
      <div className="services-title">
        <h1>Our Services</h1>
      </div>
      <div id={mobileVersion ? "first-partmb" : "first-part"}>
        <div className="text">
          <h1> You can be a star too!</h1>
          
          <p>
          While everyone’s busy helping those who are already in the game, we’re here for the
newcomers—the ones who’ve never touched social media but dream of becoming stars. 🚀✨
          </p>
        </div>
        <div className="pic">
          <img src={star} alt="" />
        </div>
      </div>

      <div
        id={mobileVersion ? "first-partmb" : "first-part"}
        className="reverse"
      >
        <div className="text">
          <h1>Editing & Post-Production</h1>
          <p>
          Our expert editors work their magic to make sure your videos are polished, optimized, and ready
to shine on every platform. 🎬✨
          </p>
        </div>
        <div className="pic">
          <img src={editing} alt="" />
        </div>
      </div>

      <div id={mobileVersion ? "first-partmb" : "first-part"}>
        <div className="text">
          <h1>Viral Content Ideas</h1>
          <p>
          Stuck because you're out of ideas? No worries, we've got you covered. We’ve got the formula to
make your content pop—no guessing needed. 🔥🎯</p>
        </div>

        <div className="pic">
          <img src={viral} alt="" />
        </div>
      </div>

      <div
        id={mobileVersion ? "first-partmb" : "first-part"}
        className="reverse"
      >
        <div className="text">
          <h1>Viral Optimization</h1>
          <p>
          If your content is solid but the internet just isn’t vibing with it, there might be some hidden
issues. Don’t worry, we can fix that in a flash. 🔧⚡️
          </p>
        </div>

        <div className="pic">
          <img src={optimization} alt="" />
        </div>
      </div>
      <div
        id={mobileVersion ? "first-partmb" : "first-part"}
        className="reverse"
      >
        <div className="text">
          <h1>Big Name Connections</h1>
          <p>
          Connect with a powerhouse of influencers across diverse niches and regions. Team up, level
          up, and watch your growth skyrocket! 🚀💥
          </p>
        </div>

        <div className="pic">
          <img src={bigName} alt="" />
        </div>
      </div>
     

      <ToastContainer />
    </main>
  );
};

export default Services;